import { apiClient } from "../config/api.config";

/** Answer of every PIN route that unlocks the session (MED-1621). */
export interface PinStatusResponse {
  hasPin: boolean;
  locked: boolean;
}

export interface PinResetRequestResponse {
  channel: "EMAIL" | "SMS";
  destinationMasked: string;
}

/** POST /api/v1/account/pin — first PIN of the user. */
export function createPin(pin: string) {
  return apiClient.request<PinStatusResponse>({
    method: "post",
    url: "/account/pin",
    data: { pin },
  });
}

/** POST /api/v1/account/pin/unlock — unlocks the session. */
export function unlockWithPin(pin: string) {
  return apiClient.request<PinStatusResponse>({
    method: "post",
    url: "/account/pin/unlock",
    data: { pin },
  });
}

/** PUT /api/v1/account/pin — replaces the PIN (a wrong current PIN counts as a failed attempt). */
export function changePin(currentPin: string, newPin: string) {
  return apiClient.request<PinStatusResponse>({
    method: "put",
    url: "/account/pin",
    data: { currentPin, newPin },
  });
}

/** POST /api/v1/account/pin/reset/request — sends a one-time code to the user. */
export function requestPinReset() {
  return apiClient.request<PinResetRequestResponse>({
    method: "post",
    url: "/account/pin/reset/request",
  });
}

/** POST /api/v1/account/pin/reset/confirm — new PIN with the one-time code. */
export function confirmPinReset(otp: string, newPin: string) {
  return apiClient.request<PinStatusResponse>({
    method: "post",
    url: "/account/pin/reset/confirm",
    data: { otp, newPin },
  });
}

/** Answer of PUT /api/v1/account/pin/lock_delay (MED-1643). */
export interface PinLockDelayResponse {
  lockMinutes: number;
}

/** PUT /api/v1/account/pin/lock_delay — minutes without activity before the session locks (5, 15, 30, 60). */
export function updatePinLockDelay(lockMinutes: number) {
  return apiClient.request<PinLockDelayResponse>({
    method: "put",
    url: "/account/pin/lock_delay",
    data: { lockMinutes },
  });
}

/** POST /api/v1/account/activity — keeps the server lock timer from firing while the user is active (204). */
export function postActivity() {
  return apiClient.request<void>({
    method: "post",
    url: "/account/activity",
  });
}
